"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERegistrationStep = void 0;
var ERegistrationStep;
(function (ERegistrationStep) {
    ERegistrationStep["AgcoId"] = "agcoId";
    ERegistrationStep["Password"] = "password";
    ERegistrationStep["Details"] = "details";
    ERegistrationStep["Address"] = "address";
    ERegistrationStep["BusinessInformation"] = "businessInformation";
    ERegistrationStep["PhoneNumber"] = "phoneNumber";
    ERegistrationStep["Confirmation"] = "confirmation";
})(ERegistrationStep = exports.ERegistrationStep || (exports.ERegistrationStep = {}));
